import { render, staticRenderFns } from "./MdTableClientPag.vue?vue&type=template&id=5a625fb4&"
import script from "./MdTableClientPag.vue?vue&type=script&lang=js&"
export * from "./MdTableClientPag.vue?vue&type=script&lang=js&"
import style0 from "./MdTableClientPag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports